<form
  [formGroup]="form"
  [patchForm]="rolePermissions"
  (ngSubmit)="onFormSubmit()"
  [canEdit]="[accessRights.RolePermissions_write]"
>
  <div class="mb-4">
    <label class="form-label">
      <span
        class="text-danger"
        attr.aria-label="{{ 'general.required' | translate }}"
        >*</span
      >
      {{ 'productModule.product' | translate }}
      <small>({{ 'general.isRequired' | translate }})</small>
      <i
        class="ms-2 fa fa-question-circle"
        role="button"
        tabindex="0"
        [tooltip]="'rolePermissionsModule.descriptionTooltip' | translate"
      ></i>
    </label>
    <product-select-input
      [products]="products$ | async"
      formControlName="productId"
      (search)="onSearchProducts($event)"
      [allowClearing]="true"
      [placeholder]="'rolePermissionsModule.selectProduct' | translate"
      [isFromRolePermissionCreation]="true"
      aria-required="true"
    ></product-select-input>
  </div>
  <div class="mb-4">
    <label class="form-label">
      <span
        class="text-danger"
        attr.aria-label="{{ 'general.required' | translate }}"
        >*</span
      >
      {{ 'general.role' | translate }}
      <small>({{ 'general.isRequired' | translate }})</small>
      <i
        class="ms-2 fa fa-question-circle"
        role="button"
        tabindex="0"
        [tooltip]="'rolePermissionsModule.roleTooltip' | translate"
      ></i>
    </label>

    <ng-select
      [items]="roles$ | async"
      bindLabel="description"
      bindValue="id"
      formControlName="roleId"
      [placeholder]="'rolePermissionsModule.selectRole' | translate"
      [(ngModel)]="selectedRoleId"
      aria-required="true"
    >
    </ng-select>

    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="form.controls?.roleId?.dirty && form.controls?.roleId?.invalid"
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
    </p>
  </div>

  <div class="row">
    <fieldset class="mb-4 col-md-auto">
      <legend class="form-label">
        <span
          class="text-danger"
          attr.aria-label="{{ 'general.required' | translate }}"
          >*</span
        >
        {{ 'rolePermissionsModule.validFrom' | translate }}
        <small>({{ 'general.isRequired' | translate }})</small>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          tabindex="0"
          [tooltip]="'rolePermissionsModule.validFromTooltip' | translate"
        ></i>
      </legend>
      <datetime-input
        formControlName="validFrom"
        [attr.aria-invalid]="
          form.controls?.validFrom.dirty && form.controls?.validFrom.invalid
            ? 'true'
            : null
        "
      ></datetime-input>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls?.validFrom.dirty && form.controls?.validFrom.invalid
        "
      >
        <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
        {{ 'rolePermissionsModule.validFrom' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </fieldset>

    <fieldset class="mb-4 col-md-auto">
      <legend class="form-label">
        <span
          class="text-danger"
          attr.aria-label="{{ 'general.required' | translate }}"
          >*</span
        >
        {{ 'rolePermissionsModule.validTill' | translate }}
        <small>({{ 'general.isRequired' | translate }})</small>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          tabindex="0"
          [tooltip]="'rolePermissionsModule.validTillTooltip' | translate"
        ></i>
      </legend>

      <datetime-input
        formControlName="validTill"
        [attr.aria-invalid]="
          form.controls?.validTill.dirty && form.controls?.validTill.invalid
            ? 'true'
            : null
        "
      ></datetime-input>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls?.validTill.dirty && form.controls?.validTill.invalid
        "
      >
        <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
        {{ 'rolePermissionsModule.validTill' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </fieldset>
  </div>

  <div class="form-footer">
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="!form.dirty"
      [canSee]="[accessRights.RolePermissions_write]"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
